export const mainLink = window.location.origin
// export const mainLink = 'http://127.0.0.1:8000'